
import { namespace } from 'vuex-class';
import { Vue, Component, Prop } from 'vue-property-decorator';

import { MonetizationType } from '@/@types/graphql-types';

import {
	TitleListOfferProviderFragment,
	GetTitleListOfferProvidersDocument,
	GetTitleListOfferProvidersQueryVariables,
} from '@/pages/graphql/queries/GetTitleListOfferProviders.query';

import ProviderIcon from '@/components/picture/ProviderIcon.vue';

const Language = namespace('language');

@Component({
	name: 'ListOffersComparison',
	components: { ProviderIcon },
	apollo: {
		listOffers: {
			query: GetTitleListOfferProvidersDocument,
			variables(): GetTitleListOfferProvidersQueryVariables {
				return {
					nodeId: this.listId,
					country: this.country,
					first: this.listSize,
					offersFilter: {
						bestOnly: true,
						preAffiliate: true,
						monetizationTypes: [
							MonetizationType.Flatrate,
							MonetizationType.FlatrateAndBuy,
							MonetizationType.Ads,
							MonetizationType.Free,
						],
					},
				};
			},
			update: data => data.node.titles.edges ?? [],
		},
	},
})
export default class ListOffersComparison extends Vue {
	@Prop({ required: true }) listId: string;
	@Prop({ required: true }) listSize: number;

	// Number of providers to compare
	@Prop({ default: 5 }) chartSize: number;

	@Language.Getter language: string;
	@Language.Getter country: string;

	listOffers: NonNullable<TitleListOfferProviderFragment>[] = [];

	barStyle(count: number, total: number) {
		return {
			width: `calc(${count} / ${total} * 100%)`,
		};
	}

	get topProvider() {
		return this.offerAggregate[0] ?? { id: '', count: 0, name: '' };
	}

	get offerAggregate() {
		const aggregate: { [id: string]: { id: number; count: number; name: string } } = {};

		this.listOffers
			.flatMap(({ node }) => node.flatrate)
			.forEach(offer => {
				if (!(offer.package.id in aggregate)) {
					aggregate[offer.package.id] = {
						id: offer.package.packageId,
						count: 0,
						name: offer.package.clearName,
					};
				}

				aggregate[offer.package.id].count++;
			});

		const result = Object.values(aggregate);
		result.sort((a, b) => b.count - a.count);

		return result;
	}
}
